import type { PayloadAction } from "@reduxjs/toolkit";
import { RecordMode } from "Data/Objects/RecordSettings";
import { createAppSlice } from "Data/Redux/Store";
import type { RecordSettingsState } from "Interfaces";

const initialState: RecordSettingsState = {
	recordingMode: RecordMode.EVENT,
	storageOption: "SDCard",
	continuousRecordingOption: "secondStream",
	eventRecordingOption: "firstStream",
	recordingSchedule: {
		always: true ,
		weekday: false,
		weekend: false
	},
	preRecordingTime: 5,
	postRecordingTime: 30
};

// #region reducers
export const setRecordSettingsReducer = (state: RecordSettingsState, action: PayloadAction<RecordSettingsState>) => {
	if (!action.payload) {
		return;
	}

	return action.payload;
};

// #endregion

// #region selectors
export const getRecordSettings = (state: RecordSettingsState) => {
	return state;
};

// #endregion

const recordSettingsSlice = createAppSlice({
	name: "recordSettings",
	initialState,
	reducers: {
		setRecordSettingsAction: setRecordSettingsReducer
	},
	selectors: {
		selectRecordSettings: getRecordSettings
	}

});

export default recordSettingsSlice;

export const { setRecordSettingsAction } = recordSettingsSlice.actions;
export const { selectRecordSettings } = recordSettingsSlice.selectors;
